export default {
  LIST_VIEW: 'LIST_VIEW',
  TABLE_VIEW: 'TABLE_VIEW',
};
